import api from './api';
import amorcApi from './amorc-api';
import applyApiInterceptors from './interceptors';

export {
  api,
  applyApiInterceptors,
  amorcApi,
};
